import { Button, Delete, Modal } from 'rbx';
import * as React from 'react';
import { useMutation } from '@apollo/client';
import { useNavigate } from 'react-router-dom';

import IBasketModel from '../../../models/IBasketModel';
import { notification } from '../../../utils/notification';
import FormField from '../../ui/FormField';
import ModalContainer from '../../ui/ModalContainer';
import { BASKET_DELETE_MUTATION, BASKET_LIST_QUERY } from './../../../api/GraphQLQueries/Basket';
import Routing from './../../../Routing';

interface IProps {
    basket: IBasketModel;
}

const BasketDeleteMutation: React.FC<IProps> = ({ basket }) => {
    const navigate = useNavigate();
    const [showBasketDeleteModal, setShowBasketDeleteModal] = React.useState(false);
    const [basketNameConfirm, setBasketNameConfirm] = React.useState('');
    const [deleting, setDeleting] = React.useState(false);

    const [deleteBasketMutation] = useMutation(BASKET_DELETE_MUTATION, {
        onCompleted: () => {
            notification.success('Successfully deleted basket');
            navigate(Routing.BASKETS.getPath(), { replace: true });
        },
        onError: () => {
            setDeleting(false);
            notification.error('Basket delete error');
        },
        refetchQueries: [{ query: BASKET_LIST_QUERY }],
    });

    const handleDeleteBasket = () => {
        setDeleting(true);
        deleteBasketMutation({ variables: { id: basket.id } });
    };

    const toggleDeleteBasketModal = () => {
        setShowBasketDeleteModal(!showBasketDeleteModal);
        setBasketNameConfirm('');
    };

    const onBasketTitleChange = (val: string) => {
        setBasketNameConfirm(val);
    };

    return (
        <>
            <Button
                color="danger"
                onClick={toggleDeleteBasketModal}
                data-cy="basketDeleteMutation-delete-btn"
            >
                Delete Basket
            </Button>

            {showBasketDeleteModal && (
                <ModalContainer
                    isOpen={true}
                    onRequestClose={toggleDeleteBasketModal}
                >
                    <Modal.Card>
                        <Modal.Card.Head>
                            <Modal.Card.Title>Delete basket</Modal.Card.Title>
                            <Delete onClick={toggleDeleteBasketModal} />
                        </Modal.Card.Head>

                        <Modal.Card.Body>
                            <FormField
                                label="Confirm"
                                horizontal={true}
                                placeholder="Basket name"
                                value={basketNameConfirm}
                                onChange={onBasketTitleChange}
                            />
                        </Modal.Card.Body>
                        <Modal.Card.Foot align="right">
                            <Button
                                color="danger"
                                disabled={
                                    basketNameConfirm.trim() !==
                                    basket.name.trim() || deleting
                                }
                                onClick={() => {
                                    if (
                                        !(
                                            basketNameConfirm.trim() !==
                                            basket.name.trim() || deleting
                                        )
                                    ) {
                                        handleDeleteBasket();
                                    }
                                }}
                            >
                                Delete basket
                            </Button>
                        </Modal.Card.Foot>
                    </Modal.Card>
                </ModalContainer>
            )}
        </>
    );
};

export default BasketDeleteMutation;
